import { Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Config from '../config/Config';
import logo from '../assets/brand.png';

const BrandSection = () => {
  
  const { brandHeight } = Config.appearance;

  return (
    <Navbar.Brand as={Link} to="/">
      <img src={logo} alt="Brand" height={brandHeight} />
    </Navbar.Brand>
  );
};

export default BrandSection;
